import type { CertificateData } from '../types';

export const certificateData: CertificateData = {
  title: "ПОДАРОЧНЫЙ СЕРТИФИКАТ",
  subtitle: "Финская сауна",
  services: ["САУНА", "ХАММАМ", "МАССАЖ"],
  duration: 2,
  saunaType: "Финская сухая сауна",
  price: 3000,
  currency: "рублей",
  address: {
    full: "СПб, Шаврова, 26, 2 этаж",
    mapUrl: "https://yandex.ru/maps/-/CLTjfMoA"
  },
  phone: "+7 (812) 984-52-84",
  features: [
    "Запишитесь на удобную дату"
  ],
  placeName: "«ГРЕЛКА»",
  placeDescription: "Банный отдых для Женщин"
};
